<template>
  <section class="rounded-md shadow-sm w-full overflow-hidden border">
    <div id="header" class="bg-gray-50 border-b">
      <slot name="header"></slot>
    </div>
    <div
      ref="containerScroll"
      :class="`${height} overflow-auto scroll-style bg-white`"
      @scroll="onScroll"
    >
      <slot name="content"></slot>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "infiniteScroll",
  emits: ["onScroll"],
  props: {
    height: {
      type: String,
      default: "h-[500px]",
    },
  },
  methods: {
    onScroll(): void {
      const refs = this.$refs.containerScroll as HTMLDivElement;
      this.$emit("onScroll", refs);
    },
  },
});
</script>
